import Raven from 'raven-js';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { ReducedOptionsModal } from 'ui-addon-upgrades/_core/communicationMethods/ReducedOptionsModal';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { submitPql } from '../pql/submitPql';
import { loadAndOpenSalesChat } from '../utils/loadAndOpenSalesChat';
import { trackTalkToSalesPql } from '../utils/metricUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const RetailModal = ({
  handleIframeSizeChange,
  onClose,
  upgradeData,
  hideBackground,
  modalRoot,
  isGD0532ExperimentVariation
}) => {
  const onModalView = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'viewed retail modal'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    submitPql(Object.assign({}, upgradeData, {
      isRetail: true,
      isAssignable: false
    })).catch(error => {
      console.error(error);
      Raven.captureException(new Error('Error submitting PQL with retail modal'), {
        extra: {
          error
        }
      });
    });
    trackTalkToSalesPql(upgradeData.app);
  };
  const handleClickChatTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked retail chat button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: true
    });
    onClose();
  };
  const handleClickCallTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked retail phone button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
  };
  return /*#__PURE__*/_jsx(ReducedOptionsModal, {
    onModalView: onModalView,
    onClickChat: handleClickChatTrack,
    onClickCall: handleClickCallTrack,
    onClose: () => onClose(),
    isRetail: true,
    upgradeData: upgradeData,
    modalRoot: modalRoot,
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    isGD0532ExperimentVariation: isGD0532ExperimentVariation
  });
};